module.exports = __webpack_public_path__ + "static/media/modelo_2.d7b8d593.svg";